<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Part I</h1>
</div>
</div>
<div class="figure">
<span class="img"><img alt="" src="images/01-post-investigates_woodbern_epub.jpg"/></span></div>
<div class="figcaption" style="text-align: left;">
	Bob Woodward (left) and Carl Bernstein in the Washington Post newsroom. (<em>Image by Ken Feil/The Washington Post)</em></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap75828.vue?0f2d3c8a